import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaUtensils, FaMoneyBillWave, FaClipboardList, FaPlus, FaList,
} from 'react-icons/fa';
import { FaBangladeshiTakaSign } from 'react-icons/fa6';

function SalesDashboard() {
  // Mock data for Al Baik menu items
  const salesData = [
    {
      id: 1, product: 'Chicken Broast Meal', quantity: 32, total: 9600, date: '2025-06-25',
    },
    {
      id: 2, product: 'Beef Shawarma', quantity: 18, total: 4500, date: '2025-06-26',
    },
    {
      id: 3, product: 'Chicken Burger', quantity: 25, total: 6250, date: '2025-06-27',
    },
    {
      id: 4, product: 'Falafel Wrap', quantity: 12, total: 2400, date: '2025-06-28',
    },
    {
      id: 5, product: 'Mango Juice', quantity: 40, total: 4000, date: '2025-06-28',
    },
  ];

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Sales Dashboard</h2>
        <div className="flex space-x-3">
          {/* Replace <a> with <Link> */}
          <Link
            to="/sales/entry"
            relative="route"
            className="flex items-center bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg transition-colors"
          >
            <FaPlus className="mr-2" />
            New Sale
          </Link>

          <Link
            to="/sales/transactions"
            relative="route"
            className="flex items-center bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg transition-colors"
          >
            <FaList className="mr-2" />
            View All Sales
          </Link>
        </div>
      </div>

      {/* Sales Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="bg-white p-6 rounded-xl shadow-md border-l-4 border-red-500">
          <div className="flex justify-between items-center">
            <div>
              <p className="text-gray-500 text-sm font-medium">Today&#39;s Sales</p>
              <p className="text-2xl font-bold text-gray-800 mt-1 flex items-center">
                <FaBangladeshiTakaSign className="mr-1" />
                {' '}
                24,500
              </p>
            </div>
            <FaMoneyBillWave className="text-red-500 text-3xl" />
          </div>
          <p className="text-green-600 text-sm mt-2">↑ 12% from yesterday</p>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-md border-l-4 border-blue-500">
          <div className="flex justify-between items-center">
            <div>
              <p className="text-gray-500 text-sm font-medium">Total Orders</p>
              <p className="text-2xl font-bold text-gray-800 mt-1">127</p>
            </div>
            <FaClipboardList className="text-blue-500 text-3xl" />
          </div>
          <p className="text-green-600 text-sm mt-2">↑ 8% from yesterday</p>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-md border-l-4 border-yellow-500">
          <div className="flex justify-between items-center">
            <div>
              <p className="text-gray-500 text-sm font-medium">Popular Item</p>
              <p className="text-2xl font-bold text-gray-800 mt-1">Broast Meal</p>
            </div>
            <FaUtensils className="text-yellow-500 text-3xl" />
          </div>
          <p className="text-gray-600 text-sm mt-2">45 sold today</p>
        </div>
      </div>

      {/* Recent Sales Table */}
      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        <div className="px-6 py-4 border-b flex justify-between items-center">
          <h3 className="text-lg font-semibold text-gray-800">Recent Sales</h3>
          <span className="text-sm text-gray-500">Last 5 transactions</span>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Item</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Qty</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {salesData.map((sale) => (
                <tr key={sale.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{sale.product}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{sale.quantity}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 font-medium flex items-center">
                    <FaBangladeshiTakaSign className="mr-1" />
                    {' '}
                    {sale.total.toLocaleString()}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{sale.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default SalesDashboard;
